import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { object, shape } from "prop-types";
import { LazyCollection, LazyLoadImages, replaceAllStoriesInCollection, WithPreview } from "@quintype/components";

import TaboolaScript from "../ads/taboola-ad/load-taboola-ad";
import NewIframeTopBanner from "../atoms/new-iframe-top-banner";
import TaboolaAd from "../ads/taboola-ad";
import { SpinnerLoader } from "../common/loader";

import { getCollectionTemplate } from "../get-collection-template";

export const HomePage = ({ data }) => {
  // eslint-disable-next-line no-unused-vars

  const filterCollections = data?.collection?.items?.filter((i) => i.items.length);
  const collection1 = { ...data?.collection };
  collection1.items = [filterCollections && filterCollections[0]];
  const remainingCollection = { ...data?.collection };
  remainingCollection.items = filterCollections?.slice(1);
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const topBannerConfig = qtState?.data?.frontendConfig?.topBannerConfig;
  const prevIsUserLoginRef = useRef(isUserLogin);
  const [isAuthReloading, setIsAuthReloading] = useState(false);
  const [isSSOCallback, setIsSSOCallback] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const searchParams = new URLSearchParams(window.location.search);
    if (
      searchParams.has("access_token") &&
      searchParams.has("refresh_token")
    ) {
      setIsSSOCallback(true);
    }
  }, []);

  useLayoutEffect(() => {
    if (prevIsUserLoginRef.current !== isUserLogin && isSSOCallback) {
      prevIsUserLoginRef.current = isUserLogin;
      setIsAuthReloading(true);
      return;
    }

    prevIsUserLoginRef.current = isUserLogin;
  }, [isUserLogin, isSSOCallback]);

  useEffect(() => {
    if (!isAuthReloading || typeof window === "undefined") return;

    requestAnimationFrame(() => {
      window.location.reload();
    });
  }, [isAuthReloading]);

  const avoidUrls = Array.isArray(topBannerConfig?.avoidUrl)
    ? topBannerConfig.avoidUrl
    : typeof topBannerConfig?.avoidUrl === "string"
      ? [topBannerConfig.avoidUrl]
      : [];

  const checkUrls = [
    "http://localhost:3000",
    "https://prajavani-web.qtstage.io/",
    "https://prajavani-web.qtstage.io",
    "https://prajavani-training-web.quintype.io/",
    "https://prajavani-training-web.quintype.io",
    "https://prajavani.net/",
    "https://prajavani.net"
  ];
  const avoidHomePage = checkUrls.some((url) =>
    avoidUrls.includes(url)
  );

  if (isSSOCallback || isAuthReloading) {
    return <SpinnerLoader />;
  }

  return (
    <>
      <div className="container">
        {!avoidHomePage && <NewIframeTopBanner sectionPage={false} />}
        <TaboolaScript type="homepage" />
        <LazyLoadImages>
          <LazyCollection
            minHeight={0}
            collection={data?.collection}
            collectionTemplates={getCollectionTemplate}
            lazyAfter={2}
            className="lazy-collection"
          />
        </LazyLoadImages>

        {!isAdfree && <TaboolaAd container="taboola-below-home-thumbnails" placement="Below Home Thumbnails" mode="thumbnails-d" />}
      </div>
    </>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object
  })
};

export const HomePagePreview = WithPreview(HomePage, (data, story) =>
  Object.assign({}, data, {
    collection: replaceAllStoriesInCollection(data.collection, story)
  })
);
